import React, { memo } from 'react';
import classNames from 'classnames/bind';
import { Text } from '@beef/ui-kit';
import { Picture } from "../../../Picture";
import styles from "./styles.module.pcss";
var cn = classNames.bind(styles);
export var TopParameters = /*#__PURE__*/memo(function (_ref) {
  var parameters = _ref.parameters,
    cardType = _ref.cardType;
  return /*#__PURE__*/React.createElement("div", {
    className: cn('top-parameters', cardType && "top-parameters--".concat(cardType)),
    "data-t-id": "components-TopParameters"
  }, parameters === null || parameters === void 0 ? void 0 : parameters.map(function (parameter) {
    return /*#__PURE__*/React.createElement("div", {
      className: cn('top-parameter')
    }, /*#__PURE__*/React.createElement("div", {
      className: cn('picture-wrapper')
    }, /*#__PURE__*/React.createElement(Picture, {
      className: cn('picture'),
      src: parameter.icon
    })), /*#__PURE__*/React.createElement("div", {
      className: cn('top-parameter__text')
    }, /*#__PURE__*/React.createElement(Text, {
      size: "size6-r"
    }, parameter.value)));
  }));
});